// extracted by mini-css-extract-plugin
export default {"sentinel":"InfiniteScrollSentinel_sentinel__X0B3e"};